import { envConfig } from '../../../config/env';

export default {
  hero: {
    eyebrow: 'VR实验室 VR Lab',
    title: '暨南大学 VR 实验室',
    subtitle: '聚焦虚拟现实、人机交互、人工智能与智慧教育，每-向 2-3 名优秀学生开放合作机会。',
    backgroundImage: `${envConfig.cdnBase}/backgroundImage.jpg`,
    primary: { text: '了解研究', to: '/publications' },
    secondary: { text: '走近团队', to: '/members' },
  },
  intro: {
    paragraphs: [
      '由<strong>高博宇博导</strong>领衔的<strong>暨南大学网络空间安全学院 VR 实验室</strong>与<strong>广东智慧教育研究院</strong>，深耕虚拟现实多通道可信交互，形成虚拟现实、人机交互、人工智能与智慧教育、应用安全等方向的交叉研究布局。',
      '团队主持国家自然科学基金面上与青-项目、国家重点研发计划子课题、广东省自然科学基金等 <span style="color: #2b5cd8; font-weight: bold;">10 余项</span> 科研项目，在 <span style="background-color: #f2f4f7; color: #1f2329; padding: 2px 6px; border-radius: 4px;">IEEE VR</span>、<span style="background-color: #f2f4f7; color: #1f2329; padding: 2px 6px; border-radius: 4px;">IEEE TVCG</span>、<span style="background-color: #f2f4f7; color: #1f2329; padding: 2px 6px; border-radius: 4px;">IJHCS</span> 等国际期刊会议发表 <span style="color: #2b5cd8; font-weight: bold;">30 余篇</span> 论文，欢迎学习态度积极、自我驱动的研究生与本科生发邮件联系并尽早加入课题组。'
    ]
  },
  news: {
    heading: '最新动态',
    items: [
      {
        date: '2025-11-12',
        title: '祝贺<strong>高博宇老师</strong>担任 <span class="home__news-badge">IEEE VR 2026</span>、<span class="home__news-badge">IEEE ISMAR 2025</span> 程序委员会委员及 <span class="home__news-badge">ICXR 2025</span> Poster Chair！',
      },
      {
        date: '2025-11-08',
        title: '祝贺<strong>博士生陈磊</strong>的基于大模型的智能评分工作被 <span class="home__news-badge">AAAI 2026</span> 录用！',
      },
      {
        date: '2025-10-28',
        title: '与<strong>La Trobe 涂老师</strong>合作的基于触摸板的交互研究在 <span class="home__news-badge">IEEE TVCG</span> 在线发表！',
      },
      {
        date: '2025-07-24',
        title: '祝贺课题组<strong>冠宇</strong>、<strong>紫君</strong>、<strong>子博</strong>的3篇论文被 <span class="home__news-badge">IEEE ISMAR 2025</span> 接收！',
      },
      {
        date: '2025-07-24',
        title: '祝贺<strong>万婷洁老师</strong>一篇论文被 <span class="home__news-badge">IEEE ISMAR 2025</span> 接收！',
      },
      {
        date: '2025-01-17',
        title: '祝贺<strong>博士生紫君</strong>同学的第一篇论文被 <span class="home__news-badge">CHI 2025</span> 接收！',
      },
    ],
  },
  research: {
    heading: '最新研究',
    more: '查看更多成果'
  }
};
